import { useMutation, UseMutationResult, useQuery, QueryResult } from '@eika-infrastruktur/react-query';
import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { AccountGroup } from '../generated-types';
import { GroupsUpdateArgs, getAccountsGroups, updateGroupsAndProperties } from '../services/accountsGroupsService';

export function useAccountsGroupsQuery(): QueryResult<AccountGroup[]> {
    return useQuery<AccountGroup[]>({
        queryKey: ['get-accounts-groups'],
        queryFn: getAccountsGroups,
    });
}

export const useUpdateGroupsAndProperties = (): UseMutationResult<
    void,
    RequestExceptionWithResponse,
    GroupsUpdateArgs
> => useMutation<void, RequestExceptionWithResponse, GroupsUpdateArgs>({ mutationFn: updateGroupsAndProperties });
